module.exports = __webpack_public_path__ + "img/garten2.18e53236.svg";